import {
  BadgeOption,
  POC_OPTIONS,
} from "../../../../constants/submissionSummaryOptions";
import { PocAssignee, PocAssigneeLabels } from "../../../../enums/pocAssignee";

/**
 * Resolves the badge displayed for the submission summary POC field.
 *
 * {@link POC_OPTIONS} is a curated subset of the assignee roster, so an order
 * auto-filled from `assignee_id` can hold a valid UID that has no matching
 * option. Those fall back to a badge built from the roster label, keeping the
 * value visible instead of rendering an empty dropdown.
 *
 * @param poc - Firebase UID currently held in the POC field
 * @returns Badge to render as selected, or undefined when the UID is unknown
 */
export const getPocBadge = (poc: string): BadgeOption | undefined => {
  const trimmed = poc?.trim();
  if (!trimmed) {
    return undefined;
  }

  const fromOptions = POC_OPTIONS.find((badge) => badge.id === trimmed);
  if (fromOptions) {
    return fromOptions;
  }

  const label = PocAssigneeLabels[trimmed as PocAssignee];
  if (!label) {
    return undefined;
  }

  return {
    id: trimmed,
    text: label,
    textColor: "black",
    bgColor: "white",
  };
};
